import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { ISanctionedGroupMySuffix } from 'src/app/shared/model/sanctioned-group-my-suffix.model';

type EntityResponseType = HttpResponse<ISanctionedGroupMySuffix>;
type EntityArrayResponseType = HttpResponse<ISanctionedGroupMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class SanctionedGroupMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/sanctioned-groups';
    private resourceUrlView = SERVER_API_URL + 'api/sanctioned-groups/view';
    private resourceUrlCargoUpadate = SERVER_API_URL + 'api/sanctioned-groups/add-cargos';

    constructor(private http: HttpClient) {}

    create(sanctionedGroup: ISanctionedGroupMySuffix): Observable<EntityResponseType> {
        return this.http.post<ISanctionedGroupMySuffix>(this.resourceUrl, sanctionedGroup, { observe: 'response' });
    }

    update(sanctionedGroup: ISanctionedGroupMySuffix): Observable<EntityResponseType> {
        return this.http.put<ISanctionedGroupMySuffix>(this.resourceUrl, sanctionedGroup, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<ISanctionedGroupMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<ISanctionedGroupMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
    view(id: number): Observable<EntityResponseType> {
        return this.http.get<ISanctionedGroupMySuffix>(`${this.resourceUrlView}/${id}`, { observe: 'response' });
    }
    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<ISanctionedGroupMySuffix>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }

    findByCountryId(id: number, countryId: number): Observable<EntityResponseType> {
        return this.http.get<ISanctionedGroupMySuffix>(`${ SERVER_API_URL + 'api/sanctioned-group'}/${id}?countryId=${countryId}`, {observe: 'response' });
    }

    createSanctionGroupByCountryId(sanctionedGroup: ISanctionedGroupMySuffix, countryId: any): Observable<EntityResponseType> {
        return this.http.post<ISanctionedGroupMySuffix>(`${this.resourceUrl}/${countryId}`, sanctionedGroup, { observe: 'response' });
    }

    cargoUpdate(sanctionedGroup: ISanctionedGroupMySuffix): Observable<EntityResponseType> {
        return this.http.put<ISanctionedGroupMySuffix>(this.resourceUrlCargoUpadate, sanctionedGroup, { observe: 'response' });
    }
}
